"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cumulative = void 0;
exports.cumulative = [0, 31, 62, 93, 124, 155, 186, 216, 246, 276, 306, 336];
